module.exports = __webpack_public_path__ + "static/media/arrow-alt-from-left.eee8b111.svg";